import React, { Fragment, useEffect, useState } from 'react';
import { Col, Card, CardHeader, Table, Form, FormGroup, Input, ModalFooter, Row } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Btn } from '../../AbstractElements';
import CommonModal from '../../Components/Modals/modal';
import { ModalToggle, addrecordedClass, getrecordedClass } from '../../store/recordedClassSlice';
import { getrecordedSubject } from '../../store/recordedSubjectSlice';
import Checkbox from '../../Components/ChackBoxCell/ChackBox';
import { useLocation } from 'react-router';

const RecordedClassTable = () => {
  const storeVar = useSelector(state => state.recordedClass);
  const subjectVar = useSelector(state => state.recordedSubject);
  const dispatch = useDispatch();
  const location = useLocation();

  const [mainId, setMainId] = useState('');
  const [selectedSubjectId, setSelectedSubjectId] = useState('');
  const [selectedChapters, setSelectedChapters] = useState({});


  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const id = searchParams.get("id") || "";
    setMainId(id);
    dispatch(getrecordedClass(id));
    dispatch(getrecordedSubject(10, 0, "active", ""));
  }, []);

  useEffect(() => {
    if (storeVar.recordedClassData?.chapters) {
      const initialMap = {};
      storeVar.recordedClassData.chapters.forEach(ch => {
        const subjectId = ch.subjectId;
        if (!initialMap[subjectId]) initialMap[subjectId] = [];
        if (!initialMap[subjectId].includes(ch._id)) {
          initialMap[subjectId].push(ch._id);
        }
      });
      setSelectedChapters(initialMap);
    }
  }, [storeVar.recordedClassData]);

  const handleSubjectChange = (e) => {
    setSelectedSubjectId(e.target.value);
  };

  const handleChapterToggle = (chapterId) => {
    setSelectedChapters((prev) => {
      const current = prev[selectedSubjectId] || [];
      const exists = current.includes(chapterId);
      const updated = exists
        ? current.filter(id => id !== chapterId)
        : [...current, chapterId];
      return { ...prev, [selectedSubjectId]: updated };
    });
  };

  const getSubjectChapters = () => {
    return subjectVar.recordedSubjectData.find(sub => sub._id === selectedSubjectId)?.chapters || [];
  };

  const AddToggleModal = () => {
    dispatch(ModalToggle());
  };


  const handleSaveSelectedChapters = () => {
    const allChapterIds = Object.values(selectedChapters).flat();
    dispatch(addrecordedClass({ testSeriesId: mainId, subjectIds: allChapterIds },mainId))


  };


  return (
    <Fragment>
      <Col sm='12'>
        <Card>
          <CardHeader>
            <Row>
              <Col md="10"></Col>
              <Col md="2" className='d-flex justify-content-end align-items-center'>
                <Btn attrBtn={{ color: 'info-gradien', className: 'w-100', size: 'sm', onClick: AddToggleModal }}>
                  Update Classes
                </Btn>
              </Col>
            </Row>
          </CardHeader>
          <div className='table-responsive'>
            <Table hover className='table-border-horizontal table-light'>
              <thead>
                <tr>
                  <th>Sl.No</th>
                  <th>Subject</th>
                  <th>Chapters</th>
                </tr>
              </thead>
              <tbody>
                {storeVar.recordedClassData.subjects?.map((item, index) => (
                  <tr key={index}>
                    <th scope='row'>{index + 1}</th>
                    <td>{item.title}</td>
                    <td>
                      {item.chapters?.map((ch, i) => (
                        <p key={i}>{ch.title}</p>
                      ))}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </Card>
      </Col>

      <CommonModal isOpen={storeVar.isOpenModal} title="Add Classes" toggler={AddToggleModal}>
        <Form>
          <FormGroup>
            <Input
              className="form-control btn-square"
              type="select"
              value={selectedSubjectId}
              onChange={handleSubjectChange}
            >
              <option value="">Select Subject</option>
              {subjectVar.recordedSubjectData.map((item, index) => (
                <option key={index} value={item._id}>{item.title}</option>
              ))}
            </Input>
          </FormGroup>

          {selectedSubjectId && getSubjectChapters().map((chapter) => (
            <Checkbox
              key={chapter._id}
              item={chapter}
              checked={selectedChapters[selectedSubjectId]?.includes(chapter._id)}
              onToggle={handleChapterToggle}
            />
          ))}
        </Form>

        <ModalFooter>
          <Btn attrBtn={{ color: 'secondary', onClick: AddToggleModal }}>Close</Btn>
          <Btn attrBtn={{ color: 'primary', onClick: handleSaveSelectedChapters }}>
            Save Changes
          </Btn>

        </ModalFooter>
      </CommonModal>
    </Fragment>
  );
};

export default RecordedClassTable;

